<template>
<!-- 底部 -->
<div class="footer-item">
  <p>Copyright © 上海一链企业管理有限公司 All Rights Reserved.</p>
  <p>若有疑问请咨询：0516-87796393</p>
</div>
</template>
<script>
export default {
  props: [],
  data () {
    return {
    }
  },
  created () {

  },
  computed:{
  },
  methods: {

  }
}
</script>
<style>
.footer-item{
  margin-top: 15px;
  border-top: 1px solid #DCDFE6;
  padding: 15px 0;
  font-size: 12px;
  color: #606266;
  text-align: center;
  line-height: 24px;
}
.footer-item p{
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/workBench/components/footerItem.vue